export enum Layout {
  LANDSCAPE = "ls",
  PORTRAIT = "pt",
  SQUARE = "sq",
}

export enum Border {
  NONE = "noop",
  FRAME = "frame",
  // CIRCLE = "circle",
}

export enum BorderStyle {
  NONE = "noop",
  SIMPLE = "simple",
  TRANSPARENT = "transparent",
  FANCY = "fancy",
  // CIRCLE = "circle",
}

export enum PaperSize {
  A4 = "a4",
  A3 = "a3",
  A2 = "a2",
  A1 = "a1"
}
